<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="riskCtrlList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="安全风险" align="center" prop="riskInfo.riskInfo"/>
          <el-table-column label="管控措施分类" align="center" prop="ctrlType">
            <template slot-scope="scope">
              <el-link>{{ handleCtrlType(scope.row.ctrlType) }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="管控级别" align="center" prop="ctrlGrade">
            <template slot-scope="scope">
              <el-link>{{ handleCtrlGrade(scope.row.ctrlGrade) }}</el-link>
            </template>
          </el-table-column>
        <el-table-column label="岗位责任人" align="center" prop="postPsnName"/>
        <el-table-column label="具体管控措施" align="center" prop="ctrlMeasure" />
        <el-table-column label="隐患排查内容" align="center" prop="hdContrnt"/>
        <!--                <el-table-column label="隐患描述" align="center" prop="hdDesc" />-->
<!--        <el-table-column label="创建人" align="center" prop="creator"/>-->
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改风险四色图管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="安全风险" prop="riskId">
          <el-select v-model="form.riskId" placeholder="请选择安全风险">
            <el-option
                v-for="dict in riskInfoList"
                :key="dict.riskId"
                :label="dict.riskInfo"
                :value="dict.riskId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管控措施分类" prop="ctrlType">
          <el-select v-model="form.ctrlType" placeholder="请选择" style="width: 100%">
            <el-option-group
                v-for="group in ctrlTypeArr"
                :key="group.label"
                :label="group.label">
              <el-option v-for="item in group.options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位责任人" prop="postPsnName">
          <el-input v-model="form.postPsnName" placeholder="请输入岗位责任人"/>
        </el-form-item>
        <el-form-item label="具体管控措施" prop="ctrlMeasure">
          <el-input v-model="form.ctrlMeasure" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="隐患排查内容" prop="hdContrnt">
          <el-input v-model="form.hdContrnt" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <!--              <el-form-item label="是否是包保责任履职" prop="isBDuty">
                        <el-select v-model="form.isBDuty" style="width: 100%">
                          <el-option :value="1" label="是"/>
                          <el-option :value="0" label="否"/>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="包保责任" prop="bdutyType">
                        <el-select v-model="form.bdutyType" style="width: 100%">
                          <el-option :value="1" label="主要负责人履职"/>
                          <el-option :value="2" label="技术负责人履职"/>
                          <el-option :value="3" label="操作负责人履职"/>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="检查项编号" prop="taskNum">
                        <el-input v-model="form.taskNum" type="textarea" placeholder="请输入内容" />
                      </el-form-item>-->
        <el-form-item label="管控方式" prop="dataSrc">
          <el-select v-model="form.dataSrc" placeholder="请选择管控方式" style="width: 100%">
            <el-option v-for="item in dataSrcArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="隐患描述" prop="hdDesc">
          <el-input v-model="form.hdDesc" type="textarea" placeholder="请输入内容"/>
        </el-form-item>


        <el-form-item label="管控级别" prop="ctrlGrade">
          <el-select v-model="form.ctrlGrade" placeholder="请选择管控级别" style="width: 100%">
            <el-option v-for="item in ctrlGradeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="form.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="数据对接省厅" prop="isTest">
          <el-select v-model="form.isTest" style="width: 100%">
            <el-option :value="0" label="是"/>
            <el-option :value="1" label="否"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {listRiskCtrl, getRiskCtrl, delRiskCtrl, addRiskCtrl, updateRiskCtrl} from "@/api/doublePrevention/riskCtrl";
import {listRiskInfo} from "@/api/doublePrevention/riskInfo";

export default {
  name: 'RiskCtrl',
  data() {
    return {
      // searchContent: '',
      riskCtrlList: [],
      riskInfoList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null,
      ctrlTypeArr: [
        {
          label: "工程技术",
          value: "HTR01",
          options: [
            {label: "工艺控制", value: "HTR0101"},
            {label: "关键设备/部件", value: "HTR0102"},
            {label: "安全附件", value: "HTR0103"},
            {label: "安全仪表", value: "HTR0104"},
            {label: "其它", value: "HTR0199"},
          ]
        },
        {
          label: "维护保养",
          value: "HTR02",
          options: [
            {label: "动设备", value: "HTR0201"},
            {label: "静设备", value: "HTR0202"},
            {label: "其它", value: "HTR0299"},
          ]
        },
        {
          label: "人员操作",
          value: "HTR03",
          options: [
            {label: "人员资质", value: "HTR0301"},
            {label: "操作记录", value: "HTR0302"},
            {label: "交接班", value: "HTR0303"},
            {label: "其它", value: "HTR0399"},
          ]
        },
        {
          label: "个体防护",
          value: "HTR04",
          options: [
            {label: "个体防护", value: "HTR0401"},
          ]
        },
        {
          label: "应急措施",
          value: "HTR05",
          options: [
            {label: "应急设施", value: "HTR0501"},
            {label: "消防设施", value: "HTR0502"},
            {label: "应急预案", value: "HTR0503"},
            {label: "其它", value: "HTR0599"},
          ]
        }
      ],
      ctrlTypeList: [
            {label: "工程技术/工艺控制", value: "HTR0101"},
            {label: "工程技术/关键设备/部件", value: "HTR0102"},
            {label: "工程技术/安全附件", value: "HTR0103"},
            {label: "工程技术/安全仪表", value: "HTR0104"},
            {label: "工程技术/其它", value: "HTR0199"},
            {label: "维护保养/动设备", value: "HTR0201"},
            {label: "维护保养/静设备", value: "HTR0202"},
            {label: "维护保养/其它", value: "HTR0299"},
            {label: "人员操作/人员资质", value: "HTR0301"},
            {label: "人员操作/操作记录", value: "HTR0302"},
            {label: "人员操作/交接班", value: "HTR0303"},
            {label: "人员操作/其它", value: "HTR0399"},
            {label: "个体防护/个体防护", value: "HTR0401"},
            {label: "应急措施/应急设施", value: "HTR0501"},
            {label: "应急措施/消防设施", value: "HTR0502"},
            {label: "应急措施/应急预案", value: "HTR0503"},
            {label: "应急措施/其它", value: "HTR0599"},
      ],
      ctrlGradeArr: [
        {label: "企业级", value: 1},
        {label: "车间级", value: 2},
        {label: "班组级", value: 3},
        {label: "部门级", value: 4},
        {label: "岗位级", value: 5},
      ],
      dataSrcArr: [
        {label: "自动化监控", value: 1},
        {label: "隐患排查", value: 2},
        {label: "其他", value: 3},
      ]
    }
  },
  created() {
    this.getRiskCtrlList();
    this.getRiskInfoList();
  },
  methods: {
    getRiskCtrlList() {
      listRiskCtrl({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.riskCtrlList = res.body.data
        this.total = res.body.cum
      })
    },
    getRiskInfoList() {
      listRiskInfo({limit: 100, curPage: 1, type: 0, isPage: 1}).then(res => {
        this.riskInfoList = res.body.data
      })
    },
    handleCtrlType(type) {
      let list = this.ctrlTypeList.filter(item => item.value === type)
      return list[0].label
    },
    handleCtrlGrade(grade) {
      let list = this.ctrlGradeArr.filter(item => item.value === grade)
      return list[0].label
    },
    pageChange(val) {
      this.curPage = val;
      this.getRiskCtrlList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加管控措施信息'
    },
    editBtn(row) {
      this.reset()
      const ctrlId = row.ctrlId
      getRiskCtrl(ctrlId).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改管控措施信息'
      })
    },
    deleteBtn(row) {
      delRiskCtrl(row.ctrlId).then(res => {
        this.$message.success('删除成功')
        this.getRiskCtrlList()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.$set(this.form, "enterpriseName", res.data);
    },
    // 表单重置
    reset() {
      this.form = {
        ctrlId: null,
        enterpriseId: null,
        riskId: null,
        ctrlType: null,
        ctrlGrade: null,
        postPsnName: null,
        ctrlMeasure: null,
        hdContrnt: null,
        hdDesc: null,
        companyCode: null,
        createTime: null,
        creator: null,
        recordStatus: null,
        isTest: null,
        isBDuty: null,
        bdutyType: null,
        taskNum: null,
        dataSrc: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.ctrlId != null) {
            updateRiskCtrl(this.form).then(response => {
              this.open = false
              this.$message.success('修改成功')
              this.getRiskCtrlList()
            })
          } else {
            addRiskCtrl(this.form).then(response => {
              this.open = false
              this.$message.success('新增成功')
              this.getRiskCtrlList()
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
